import React, { useState, useEffect } from 'react';
import '../pages/Projects.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import project1 from '../assets/project1.jpg';
import project2 from '../assets/project2.png';
import project3 from '../assets/project3.jpg';
import project4 from '../assets/project4.png';
import project5 from '../assets/project5.jpeg';
import project6 from '../assets/project6.jpg';
import cert1 from '../assets/cert1.jpg';
import cert2 from '../assets/cert2.png';
import cert3 from '../assets/cert3.jpg';
import cert4 from '../assets/cert4.jpg';
import cert5 from '../assets/cert5.jpg';
import cert6 from '../assets/cert6.jpg';
import "boxicons/css/boxicons.min.css";
import TrueFocus from '../components/TrueFocus';

// Skills data
const skills = [
  { src: "https://raw.githubusercontent.com/devicons/devicon/master/icons/javascript/javascript-original.svg", alt: "JavaScript" },
  { src: "https://raw.githubusercontent.com/devicons/devicon/master/icons/html5/html5-original.svg", alt: "HTML5" },
  { src: "https://raw.githubusercontent.com/devicons/devicon/master/icons/css3/css3-original.svg", alt: "CSS3" },
  { src: "https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original.svg", alt: "React" },
  { src: "https://raw.githubusercontent.com/devicons/devicon/master/icons/angularjs/angularjs-original.svg", alt: "Angular" },
  { src: "https://raw.githubusercontent.com/devicons/devicon/master/icons/vuejs/vuejs-original.svg", alt: "Vue.js" },
  { src: "https://raw.githubusercontent.com/devicons/devicon/master/icons/nextjs/nextjs-original.svg", alt: "Next.js" },
  { src: "https://raw.githubusercontent.com/devicons/devicon/master/icons/nodejs/nodejs-original.svg", alt: "Node.js" },
  { src: "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg", alt: "Python" },
  { src: "https://raw.githubusercontent.com/devicons/devicon/master/icons/php/php-original.svg", alt: "PHP" },
  { src: "https://cdn.jsdelivr.net/npm/simple-icons@v10/icons/laravel.svg", alt: "Laravel" },
  { src: "https://raw.githubusercontent.com/devicons/devicon/master/icons/ruby/ruby-original.svg", alt: "Ruby" },
  { src: "https://raw.githubusercontent.com/devicons/devicon/master/icons/dot-net/dot-net-original.svg", alt: ".NET" },
  { src: "https://raw.githubusercontent.com/devicons/devicon/master/icons/c/c-original.svg", alt: "C" },
  { src: "https://raw.githubusercontent.com/devicons/devicon/master/icons/csharp/csharp-original.svg", alt: "C#" },
  { src: "https://raw.githubusercontent.com/devicons/devicon/master/icons/kotlin/kotlin-original.svg", alt: "Kotlin" },
  { src: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original.svg", alt: "MongoDB" },
  { src: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original.svg", alt: "MySQL" },
  { src: "https://raw.githubusercontent.com/devicons/devicon/master/icons/tensorflow/tensorflow-original.svg", alt: "TensorFlow" },
  { src: "https://raw.githubusercontent.com/devicons/devicon/master/icons/flutter/flutter-original.svg", alt: "Flutter" },
  { src: "https://raw.githubusercontent.com/devicons/devicon/master/icons/dart/dart-original.svg", alt: "Dart" },
  { src: "https://raw.githubusercontent.com/devicons/devicon/master/icons/android/android-original.svg", alt: "Android" },
  { src: "https://img.icons8.com/color/48/microsoft-excel-2019--v1.png", alt: "Excel" },
  { src: "https://cdn.jsdelivr.net/npm/simple-icons@v10/icons/express.svg", alt: "Express.js" },
  { src: "https://cdn.jsdelivr.net/npm/simple-icons@v10/icons/cors.svg", alt: "CORS" },
  { src: "https://cdn.jsdelivr.net/npm/simple-icons@v10/icons/firebase.svg", alt: "Firebase" },

];

// Certificate data
const certificates = [
  { img: cert1  },
  { img: cert2  },
  { img: cert3  },
  { img: cert4  },
  { img: cert5  },
  { img: cert6  },
];

// Projects data
const projects = [
  { 
    img: project1, 
    title: "Lions Badminton", 
    desc: "UKM UMN", 
    fullDesc: "Lions Badminton is a student activity unit (UKM) at UMN dedicated to the sport of badminton. The organization brings together students who are passionate about badminton and provides them with opportunities to develop their skills through structured training programs. Lions Badminton has a track record of producing high-achieving members who are prepared to compete in tournaments beyond the campus level. Each member receives guidance from qualified coaches to enhance their abilities and reach their full potential in the sport.",
    techLogos: [skills[3], skills[2]],
    keyFeatures: [
      "⭐ A responsive website displaying details about Lions Badminton, including training times, team structure, and activities.",
      "⭐ Embedded YouTube videos for promotion and highlights, along with Google Maps to easily locate the training venue.",
      "⭐ A simple API implemented directly in React (no backend), optimized for smooth performance and deployment on Vercel."
    ]
  },
  { 
    img: project2, 
    title: "CNN Implementation", 
    desc: "Automated detection of lung conditions from X-ray images.", 
    fullDesc: "The project is centered on classifying chest X-ray images into three categories: COVID-19, Pneumonia, and Normal, using a Convolutional Neural Network (CNN). It incorporates extensive data preprocessing, including image augmentation techniques such as rotation, shifting, shearing, zooming, and horizontal flipping, to improve model generalization and prevent overfitting. The CNN model is trained on a labeled dataset with separate training, validation, and test splits, and its performance is evaluated through metrics like accuracy, loss, classification reports, and a confusion matrix. Visualization of accuracy and loss trends during training helps monitor model learning, while the classification report and confusion matrix provide detailed insights into prediction performance for each class. Overall, the system demonstrates a reliable approach for automated detection of lung conditions from X-ray images.",
    techLogos: [skills[8], skills[18]],
    keyFeatures: [
      "⭐ Automated Chest X-ray Classification capable of accurately distinguishing between COVID-19, Pneumonia, and Normal cases using a CNN model.",
      "⭐ Advanced Data Augmentation techniques including rotation, shifting, shearing, zooming, and horizontal flipping to enhance model generalization and robustness.",
      "⭐ Medical Analysis Support acts as a robust tool to assist healthcare professionals in analyzing and researching lung conditions."
    ]
  },
  { 
    img: project3, 
    title: "Hydrobloom", 
    desc: "Frontend interface for HydroBloom IoT system.", 
    fullDesc: "Hydrobloom is an advanced IoT-based hydroponic monitoring and automation system designed to optimize urban farming in constrained spaces. By continuously monitoring key plant parameters such as humidity, pH levels, and temperature, the system ensures ideal growing conditions and maximizes yield. The backend leverages Node.js and MongoDB for secure and scalable data management, while the frontend provides real-time visualization, historical trends, and support for multiple devices. User authentication is implemented with JWT, offering secure access and session management. Modular API routes handle sensors, devices, and IoT interactions efficiently, facilitating seamless communication between the system and connected hardware. Deployed on Vercel, Hydrobloom enables easy remote monitoring and management, providing a practical and technologically robust solution for modern urban agriculture.",
    techLogos: [skills[3], skills[7], skills[23], skills[24]],
    keyFeatures: [
      "⭐ Real-Time Monitoring & Automation continuously tracks plant parameters such as humidity, pH, and temperature, automatically activating irrigation or adjusting conditions for optimal growth.",
      "⭐ Multi-Device Management & Data Visualization to supports multiple devices with real-time dashboards, historical trend charts, and intuitive controls for efficient hydroponic system management.",
      "⭐ Secure User Authentication & Scalable Backend to Implements JWT-based authentication and a Node.js/MongoDB backend to ensure secure access, modular IoT interactions, and reliable data handling."
    ]
  },
  { 
    img: project4, 
    title: "Lampy", 
    desc: "Flutter mobile app for Lampy IoT solution.", 
    fullDesc: "This project is a smart electricity monitoring and management system using IoT technology. An ESP32 device automatically captures images of the electricity meter (KWH), which are processed by a Python application with OCR to extract the values. The data is sent to a Node.js backend via MQTT, validated, and stored in a MySQL database. The backend communicates with a Flutter mobile app, delivering real-time consumption data via WebSocket, while user authentication, account management, and device access are handled with JWT and REST APIs. The app allows users to monitor usage in real time, view historical consumption in charts, and simulate electricity token purchases with transaction history. The system is deployed on AWS Lightsail with SSL Let’s Encrypt, providing a secure, integrated, and user-friendly solution for efficient electricity monitoring and management.",
    techLogos: [skills[8], skills[7], skills[17], skills[19]],
    keyFeatures: [
      "⭐ Automated & real time monitoring using the ESP32 with OCR automatically reads KWH meter values and the data is delivered in real time.",
      "⭐ Usage history & analysis for electricity consumption data is stored in the database and visualized in charts to analyze usage patterns.",
      "⭐ Token purchase simulation for the mobile app provides a simulation of electricity token purchases along with transaction history."
    ]
  },
  { 
    img: project5, 
    title: "Formebel Indonesia", 
    desc: "OEM furniture company website and services.", 
    fullDesc: "Formebel, officially known as PT Foremost Mebel Indonesia, is an Indonesian OEM and furniture manufacturer established in 2021. The company specializes in producing high-quality, custom-made mattresses, pillows, foam products, and other furniture components, offering comprehensive services from product development and prototyping to material sourcing, mass production, and quality control. Formebel supports clients in creating branded furniture solutions tailored to their markets, emphasizing consistency, customization, and timely delivery. Its vision is to become a trusted leader in Indonesia’s furniture industry while promoting sustainable manufacturing, integrating innovation, and preparing for future export opportunities. The company aims to deliver durable, functional, and aesthetically pleasing furniture, strengthen client-centric solutions, expand domestic market presence, and foster a skilled workforce.",
    techLogos: [skills[3], skills[2]],
    keyFeatures: [
      "⭐ The website adapts seamlessly across devices, ensuring a smooth user experience on desktops, tablets, and mobile phones.",
      "⭐ Optimized structure, metadata, and content improve search engine visibility, making the site easier to discover by potential clients.",
    ]
  },
  { 
    img: project6, 
    title: "Journal App", 
    desc: "Android journaling app (U-Journal).", 
    fullDesc: "The MyJournal project is a mobile application developed as a personal diary using Android Studio and Kotlin, with full support for Firebase integration. The app allows users to register, log in, and manage daily journal entries with features like adding media, geotagging, and viewing entries on a calendar or map. Navigation is implemented with smooth transitions between screens, including Journey, Calendar, Media, and Atlas, and the layout is responsive for both smartphones and tablets. Firebase is used for authentication, data storage, and media management, ensuring real-time synchronization and secure access. The application also incorporates a custom theme for consistent UI, interactive components such as Floating Action Buttons, and a polished user experience throughout.",
    techLogos: [skills[15], skills[25]],
        keyFeatures: [
      "⭐ Firebase integration for secure login, data storage, and real-time updates for journal entries and media.",
      "⭐ Responsive & tablet-friendly layout for smooth adaptation across different screen sizes.",
      "⭐ Comprehensive navigation & interaction for intuitive navigation between screens, interactive buttons, and geotagged entry support."
    ]
  },
];

// Ganti jadi Skills
const categories = ["Skills", "Certificate", "Projects"];

export default function Projects() {
  const [activeCategory, setActiveCategory] = useState("Skills");
  const [selectedProject, setSelectedProject] = useState(null);

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const openModal = (project) => setSelectedProject(project);
  const closeModal = () => setSelectedProject(null);

return (
  <section id="projects" className="projects">
    {/* Hanya ganti heading */}
    <TrueFocus 
      sentence="My Works"
      manualMode={false}
      blurAmount={5}
      borderColor="red"
      animationDuration={0.7}
      pauseBetweenAnimations={0.5}
    />

    {/* Filter Tabs */}
    <div className="project-filters">
      {categories.map((cat, idx) => (
        <button 
          key={idx} 
          className={activeCategory === cat ? 'active' : ''} 
          onClick={() => setActiveCategory(cat)}
        >
          {cat}
        </button>
      ))}
    </div>

      {/* Content */}
      <div className="project-box">
   {activeCategory === "Skills" && (
  <div className="skills-logos">
    {skills.map((s, idx) => (
      <div key={idx} className="skill" data-aos="zoom-in" data-aos-delay={idx * 80}>
        <div className="skill-content">
          <img src={s.src} alt={s.alt} title={s.alt} />
          <p>{s.alt}</p>
        </div>
      </div>
    ))}
  </div>
)}
        {activeCategory === "Certificate" && (
          <div className="cert-grid">
            {certificates.map((c, idx) => (
              <div key={idx} className="cert-card" data-aos="fade-up" data-aos-delay={idx * 150}>
                <img src={c.img} alt={c.title} />
                <p>{c.title}</p>
              </div>
            ))}
          </div>
        )}

     {activeCategory === "Projects" && (
  projects.map((project, index) => (
    <div 
      className="project-card" 
      key={index} 
      data-aos="fade-up"
      data-aos-delay={index * 150}
      // Hapus onClick di sini
    >
      <img src={project.img} alt={project.title} />
      <h3>{project.title}</h3>
      <p>{project.desc}</p>
      <div 
        className="btn1"
        onClick={() => openModal(project)} // Pindahkan onClick hanya ke tombol
      >
        Details
      </div>
    </div>
  ))
)}

      </div>

      {/* Modal khusus Projects */}
{/* Modal khusus Projects */}
{selectedProject && (
  <div className="modal-overlay" onClick={closeModal}>
    <div className="modal-content fullscreen" onClick={e => e.stopPropagation()}>
      <button className="close-btn" onClick={closeModal}>← Back</button>

      {/* Layout utama: kiri & kanan */}
      <div className="modal-main">
        {/* Kiri: Judul & Deskripsi */}
        <div className="modal-left">
          <h2>{selectedProject.title}</h2>
          <p className="modal-desc">
            {selectedProject.fullDesc} 
          </p>
        </div>

        {/* Kanan: Gambar + Key Features */}
        <div className="modal-right">
          <img 
            src={selectedProject.img} 
            alt={selectedProject.title} 
            className="modal-img"
          />
          
          {selectedProject.keyFeatures && (
            <div className="key-features-card">
              <h3>Key Features</h3>
              <ul>
                {selectedProject.keyFeatures.map((feature, idx) => (
                  <li key={idx}>{feature}</li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>

      {/* Technology Used */}
      <h3 className="tech-title">
  <i className="bx bx-folder" style={{ marginRight: "8px" }}></i>
  Technology Used
</h3>

      <div className="tech-grid">
        {selectedProject.techLogos.map((t, idx) => (
          <div key={idx} className="tech-card">
            <img src={t.src} alt={t.alt} title={t.alt} />
            <p>{t.alt}</p>
          </div>
        ))}
      </div>
    </div>
  </div>
)}



    </section>
  );
}
